var map = {
	"./amplify-amazon-button_5.entry.js": [
		1956,
		8
	],
	"./amplify-auth-fields_9.entry.js": [
		1957,
		19
	],
	"./amplify-authenticator.entry.js": [
		1958,
		5
	],
	"./amplify-button_3.entry.js": [
		1959,
		9
	],
	"./amplify-checkbox.entry.js": [
		1960,
		26
	],
	"./amplify-confirm-sign-in_8.entry.js": [
		1961,
		6
	],
	"./amplify-container.entry.js": [
		1962,
		27
	],
	"./amplify-federated-buttons_2.entry.js": [
		1963,
		10
	],
	"./amplify-federated-sign-in.entry.js": [
		1964,
		20
	],
	"./amplify-form-field_4.entry.js": [
		1965,
		28
	],
	"./amplify-greetings.entry.js": [
		1966,
		11
	],
	"./amplify-icon-button.entry.js": [
		1967,
		29
	],
	"./amplify-icon.entry.js": [
		1968,
		23
	],
	"./amplify-link.entry.js": [
		1969,
		30
	],
	"./amplify-nav_2.entry.js": [
		1970,
		12
	],
	"./amplify-photo-picker.entry.js": [
		1971,
		21
	],
	"./amplify-picker.entry.js": [
		1972,
		22
	],
	"./amplify-radio-button_2.entry.js": [
		1973,
		7
	],
	"./amplify-s3-album.entry.js": [
		1974,
		13
	],
	"./amplify-s3-image-picker.entry.js": [
		1975,
		14
	],
	"./amplify-s3-image.entry.js": [
		1976,
		18
	],
	"./amplify-s3-text-picker.entry.js": [
		1977,
		15
	],
	"./amplify-s3-text.entry.js": [
		1978,
		16
	],
	"./amplify-select-mfa-type.entry.js": [
		1979,
		17
	],
	"./amplify-sign-in-button.entry.js": [
		1980,
		24
	],
	"./amplify-tooltip.entry.js": [
		1981,
		31
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1948;
module.exports = webpackAsyncContext;